// extracted by mini-css-extract-plugin
module.exports = {"paneTwo":"style_paneTwo__b5iVP","inputNumberHeight":"style_inputNumberHeight__316-d"};